import React from "react";
import { motion } from "framer-motion";
import { MessageSquare, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { HomeSearch, HomeComments } from "../components/WorkerFeatures";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

export default function Community() {
  useDocumentMeta({
    title: "Community · Search & Comments · JJ Argent",
    description: "Search the archive of testimonials, guestbook notes and case studies from JJ Argent's site — or leave a comment for readers to see.",
    ogUrl: "https://jjargent.com/community",
    noindex: true, // Batch 2 §10 — unpublished until there's activity
  });
  return (
    <main className="bg-[#0B0B0C] text-[#FAF9F6] min-h-screen" data-testid="community-page">
      {/* Hero */}
      <section className="border-b border-[#343437]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-16 lg:pt-32 lg:pb-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-3">
                <MessageSquare size={16} className="text-[#D8A936]" aria-hidden />
                <p className="eyebrow">Community</p>
              </div>
              <motion.h1
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mt-6 font-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight"
              >
                Search the archive.{" "}<br />
                <span className="text-[#D8A936]">Leave a comment.</span>
              </motion.h1>
              <p className="mt-8 text-[#A9A9A6] text-lg leading-relaxed max-w-2xl">
                A shared corner of the site for readers, colleagues and passers-by. Search through
                testimonials, guestbook notes and case studies — or add a comment of your own.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to="/guestbook" className="btn-ghost" data-testid="community-guestbook-cta">
                  Guestbook <ArrowUpRight size={14} />
                </Link>
                <Link to="/contact" className="btn-ghost" data-testid="community-contact-cta">
                  Full contact form <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search */}
      <HomeSearch />

      {/* Comments */}
      <HomeComments />
    </main>
  );
}
